import { createIntl, createIntlCache, IntlShape } from 'react-intl';
import locale_en from './locales/en.json';
import locale_es from './locales/es.json';
import locale_zu from './locales/zu.json';

/*
    This class is the instance we need to use for translating
    strings outside components.
    Also provides the entry point to get the current selected language 
    and translated messages for that language, those values should be used
    in IntlProvider, which is in App.tsx. 
*/
export default class I18nInstance {
    private static _i18n: IntlShape;
    private static _currentLanguage: string = 'en';

    private static _locales: any = {
        en: locale_en,
        es: locale_es,
        zu: locale_zu,
    };

    private constructor() {}

    public static get translator(): IntlShape {
        if (!I18nInstance._i18n) {
            const cache = createIntlCache();
            I18nInstance._i18n = createIntl(
                {
                    locale: this._currentLanguage,
                    messages: this._locales[this._currentLanguage],
                },
                cache,
            );
        }

        return I18nInstance._i18n;
    }

    public static get CurrentLanguage(): string {
        return I18nInstance._currentLanguage;
    }

    public static set CurrentLanguage(language: string) {
        I18nInstance._currentLanguage = language;
    }

    public static get CurrentMessages() {
        return I18nInstance._locales[I18nInstance.CurrentLanguage];
    }

    public static changeLanguage(newLanguage: any) {
        // Will only change the language if there are messages (from json file) added to locales
        if (I18nInstance._locales.hasOwnProperty(newLanguage)) {
            I18nInstance.CurrentLanguage = newLanguage;
            console.log(I18nInstance.CurrentLanguage);
            I18nInstance.translator.locale = newLanguage;
            I18nInstance.translator.messages = I18nInstance._locales[newLanguage];
        }
    }
}
